import setFilters from 'store/reducer-utils/setFilters'
import {
  DROP_INVOICES_DATA,
  RESET_INVOICES_DATA,
  SET_INVOICES_FILTER,
  SET_INVOICES_DATA,
} from 'modules/Finance/Invoices/store/types'

const initialState = {
  filters: null,
}

const setInvoicesData = (state, { payload }) => {
  return { ...state, ...payload }
}

const setInvoicesFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const dropInvoicesData = (state) => {
  return {
    ...state,
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INVOICES_DATA:
      return setInvoicesData(state, action)
    case SET_INVOICES_FILTER:
      return setInvoicesFilter(state, action)
    case DROP_INVOICES_DATA:
      return dropInvoicesData(state)
    case RESET_INVOICES_DATA:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
